module.exports = "#nav-link-space{margin-right:15px !important}\n"